import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { useFormDetails } from "Constant/apiHooks";

export default function CustomizeForm() {
  const { formId } = useParams();
  const { formDetails } = useFormDetails(formId);

  return (
    <main className="main">
      <div className="formeditor-wrapper shadow-1 box-shadow-3">
        <div className="admission-form-tab-bar global-tab">
          <Outlet context={{ formDetails }} />
        </div>
      </div>
    </main>
  );
}
